export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '姨母的诱惑',
  url: 'https://guangzhousoap.cn',
  description: '专注于成人情感文学的精品推荐平台，汇聚高品质成人文学作品推荐、情感故事解析与创作技巧分享。',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'contact@guangzhousoap.cn',
    contactType: 'customer service',
  },
  sameAs: [
    'https://weibo.com/yimude',
  ],
};

export const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '姨母的诱惑——成人情感小说精品推荐',
  url: 'https://guangzhousoap.cn',
  description: '探索「姨母的诱惑」经典情感叙事主题，汇聚高品质成人文学作品推荐、情感故事解析与创作技巧分享。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://guangzhousoap.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export function generateWebPageSchema(title: string, description: string, url: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: title,
    description,
    url,
    isPartOf: {
      '@type': 'WebSite',
      name: '姨母的诱惑',
      url: 'https://guangzhousoap.cn',
    },
  };
}

export function generateBreadcrumbSchema(items: { name: string; url: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export function generateArticleSchema(article: {
  title: string;
  description: string;
  author: string;
  date: string;
  url: string;
  image: string;
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.description,
    author: {
      '@type': 'Person',
      name: article.author,
    },
    datePublished: article.date,
    url: article.url,
    image: article.image,
    publisher: {
      '@type': 'Organization',
      name: '姨母的诱惑',
    },
  };
}

export const aboutFAQSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '「姨母的诱惑」是什么类型的平台？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '「姨母的诱惑」是一个专注于成人情感文学精品推荐的阅读平台，提供高品质的作品推荐、深度解析和创作技巧分享，面向成熟的文学爱好者群体。',
      },
    },
    {
      '@type': 'Question',
      name: '如何订阅平台的邮件通讯？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '你可以在首页底部的邮件订阅区域输入你的邮箱地址，即可免费订阅我们的每周精选推送，每次仅推送一篇优质内容。',
      },
    },
    {
      '@type': 'Question',
      name: '平台推荐的作品涵盖了哪些类型？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '平台涵盖了姨母情感故事、禁忌情感文学、成熟女性情感叙事、人性情感文学解析等多个领域，每一部推荐作品都经过编辑团队的精心筛选。',
      },
    },
  ],
};